import { ManageTable, type ManageField } from '@/components/ManageTable'
import { Input } from '@/components/ui/input'
import { usePersistentState } from '@/hooks/usePersistentState'

export default function Recharge() {
  const [filters, setFilter, clearFilters] = usePersistentState<Record<string, any>>(
    'admin:recharge:filters',
    {},
  )

  const handleResetFilters = () => {
    clearFilters()
  }

  const fields: ManageField[] = [
    {
      desc: 'account',
      field: 'account',
    },
    {
      desc: 'recharge_money',
      field: 'recharge_money',
    },
    {
      desc: 'status',
      field: 'status',
    },
    {
      desc: 'recharge_time',
      field: 'recharge_time',
    },
    {
      desc: 'order_no',
      field: 'order_no',
    },
  ]

  const filterUI = (
    <div className="flex gap-2">
      <Input
        placeholder="输入 account"
        className="w-[150px]"
        value={filters.account || ''}
        onChange={(e) => {
          const newFilters = { ...filters }
          if (e.target.value) {
            newFilters.account = e.target.value
          } else {
            delete newFilters.account
          }
          setFilter(newFilters)
        }}
      />
      <Input
        placeholder="输入 order_no"
        className="w-[150px]"
        value={filters.order_no || ''}
        onChange={(e) => {
          const newFilters = { ...filters }
          if (e.target.value) {
            newFilters.order_no = e.target.value
          } else {
            delete newFilters.order_no
          }
          setFilter(newFilters)
        }}
      />
    </div>
  )

  return (
    <div className="h-full p-6 overflow-auto">
      <h1 className="text-2xl font-bold mb-6">充值记录</h1>
      <ManageTable fields={fields} collect="recharge-log" filters={filters} filter={filterUI} onResetFilters={handleResetFilters} primaryKey="order_no" />
    </div>
  )
}
